function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1151",
  "data-name": "Group 1151",
  transform: "translate(-1405.052 -802.564)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_439",
  "data-name": "Group 439",
  transform: "translate(1405.052 802.564)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_438",
  "data-name": "Group 438",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_437",
  "data-name": "Group 437",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_92",
  "data-name": "Rectangle 92",
  width: 78.277,
  height: 23.502,
  rx: 11.751,
  fill: "#5575fa"
})))), /*#__PURE__*/React.createElement("text", {
  id: "Pay",
  transform: "translate(1420.368 808.193)",
  fill: "#fff",
  fontSize: 9,
  fontFamily: "Nunito-Bold, Nunito",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 9
}, "Pay")), /*#__PURE__*/React.createElement("g", {
  id: "Group_689",
  "data-name": "Group 689",
  transform: "translate(1459.582 810.932)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_135",
  "data-name": "Group 135",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_134",
  "data-name": "Group 134",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_133",
  "data-name": "Group 133"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_107",
  "data-name": "Path 107",
  d: "M9.473,20.949a.475.475,0,0,1,0-.949h5.935a.475.475,0,0,1,0,.949Z",
  transform: "translate(-9 -17.651)",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_108",
  "data-name": "Path 108",
  d: "M30.159,13.259,27.81,15.608a.475.475,0,1,1-.671-.671l2.013-2.013L27.139,10.91a.475.475,0,1,1,.671-.671l2.349,2.349A.474.474,0,0,1,30.159,13.259Z",
  transform: "translate(-22.729 -10.1)",
  fill: "#fff",
  fillRule: "evenodd"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_688",
  "data-name": "Group 688",
  transform: "matrix(0.966, 0.259, -0.259, 0.966, 1446.061, 807.192)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Donate_1228121",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_338",
  "data-name": "Path 338",
  d: "M2.529,0A2.813,2.813,0,0,0,.111,1.374c.24.049.452.095.629.148a1.479,1.479,0,0,1,1.1,1.512A1.042,1.042,0,0,1,1,4.048a2.74,2.74,0,0,1-.454.035A5.484,5.484,0,0,1,0,4.049,2.814,2.814,0,1,0,2.529,0Z",
  transform: "translate(10.382 3.978)",
  fill: "#ffdd21"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_340",
  "data-name": "Path 340",
  d: "M0,3.867A1.742,1.742,0,0,0,2.529,2.688C3.095.606.608,0,.608,0Z",
  transform: "matrix(0.966, -0.259, 0.259, 0.966, 9.239, 4.912)",
  fill: "#5575fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_339",
  "data-name": "Path 339",
  d: "M9.664,3.871a4.018,4.018,0,0,1,1.872-1.16C9.946,1.1,8.928.234,7.469.025,5.782-.216,1.517,1.34,0,1.673L1.166,6.025c.866.342,2.1,1.614,3.031,1.747A17.769,17.769,0,0,0,8.319,7.54a15.064,15.064,0,0,0,2.351.085c.756-.126.9-1.429-.309-1.793S5.957,5.2,6.411,3.5C6.708,2.388,8.4,3.142,9.664,3.871Z",
  transform: "translate(0 0)",
  fill: "#fff"
}))));

var SvgPayIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78.277,
    height: 23.502,
    viewBox: "0 0 78.277 23.502",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPayIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pay-icon.e5286d8d.svg";
export { ForwardRef as ReactComponent };